import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CookieService } from 'ngx-cookie-service'
import { CookiesConsentComponent } from '../components/cookies-consent/cookies-consent.component'
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class CookiesConsentService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private drawerService: NzDrawerService,
  ) {}

  private readonly apiURL: string = environment.apiUrl
  private readonly cookieName: string = '__spas_cookies_consent'
  private drawerRef: NzDrawerRef

  public open(): void {
    this.drawerRef = this.drawerService.create<CookiesConsentComponent, any>({
      nzHeight: '100px',
      nzPlacement: 'bottom',
      nzContent: CookiesConsentComponent,
      nzClosable: false,
      nzMask: false,
      nzWrapClassName: 'cookies-consent-drawer',
    })
  }

  public close(): void {
    if (this.drawerRef != null && !this.cookieConsentAccepted()) {
      this.drawerRef.close()
    }
  }

  public cookieConsentAccepted(): boolean {
    return this.cookieService.check(this.cookieName)
  }

  public setCookieConsent(isAccepted: boolean): void {
    this.http
      .post(this.apiURL + '/user/consent', { accepted: isAccepted }, { withCredentials: true })
      .subscribe({
        complete: () => this.drawerRef?.close(),
        error: () => this.drawerRef?.close(),
      })
  }
}
